


















import { Component, Watch, Vue } from 'vue-property-decorator';
import { Message } from 'element-ui';
import ConfirmationModal from '@/components/layout/ConfirmationModal.vue';
import NewContent from '@/components/layout/banners/NewContent.vue';
import Notifications from '@/components/notification/Notifications.vue';
import SideBar from '@/components/layout/SideBar.vue';

import rollbar from '@/plugins/rollbar';

import { Alert, ConfirmationData } from '@/types/types';
import { OperatorFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    NewContent,
    Notifications,
    'confirmation-modal': ConfirmationModal,
    'side-bar': SideBar
  }
})
export default class App extends Vue {
  private confirmationData?: ConfirmationData | null = null;
  private message = Message;

  get isLoginPage() {
    return this.$route.meta.public;
  }

  @Watch('$store.state.Alert.alert')
  public alertWatcher(alert: Alert) {
    if (alert) {
      this.message({
        showClose: !alert.time,
        duration: alert.time,
        message: alert.message,
        type: alert.type
      });
    }
  }

  @Watch('$store.state.App.confirmationModalData')
  private setConfirmationModalProps(newProps: any) {
    this.confirmationData = newProps;
  }

  @Watch('$store.state.User.profile')
  private toolsInit(user: OperatorFields) {
    if (this.$heap) {
      this.$heap.identify(user.id);
      this.$heap.addUserProperties({
        Name: user.name,
        Email: user.email
      });
    }

    let person = null;
    if (user) {
      person = {
        id: user.id,
        username: user.name,
        email: user.email
      };
    }

    rollbar.configure({
      payload: { person }
    });
  }
}
